const messages = {
  title: "Vouchers",
  short_description:
    "U vindt hier uw lijst met vouchers. U kunt deze delen met uw klant. Vouchers zijn eenmalig te gebruiken.",
  table: {
    headers: {
      voucher: "Voucher codes",
      company: "Bedrijf",
      street: "Straat",
      postcode: "Postcode",
      location: "Plaats",
      solved_at: "Datun",
      points: "Aantal punten via de code",
    },
  },
  exchange: {
    title: "Vul uw code in om punten te krijgen",
    pointsLabel: "Vul hier de code in:",
    result: "Aantal punten:",
  },
};

export default {
  messages,
};
